import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '1220px',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '130px',
    margin: '0 auto',
    padding: '0 30px',

    [theme.breakpoints.down('sm')]: {
      rowGap: '13px',
      padding: '0 21px',
      // overflow: 'hidden',
    },
  },
}));

const ContentWrap = ({ className, children, overfloHidden = true }) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.root} ${className}`} style={{ overflow: overfloHidden ? 'hidden' : '' }}>
      {children}
    </Box>
  );
};

ContentWrap.defaultProps = {
  children: <></>,
  className: '',
  overfloHidden: true
};

ContentWrap.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  overfloHidden: PropTypes.bool
};

export default ContentWrap;
